import AbrasioniIcon from '../../../shared/Icons/symptoms/AbrasioniIcon';
import AcetoneNeiBambiniENegliAdultiIcon from '../../../shared/Icons/symptoms/AcetoneNeiBambiniENegliAdultiIcon';
import AciditaDiStomacoIcon from '../../../shared/Icons/symptoms/AciditaDiStomacoIcon';
import AcneIcon from '../../../shared/Icons/symptoms/AcneIcon';
import AerofagiaIcon from '../../../shared/Icons/symptoms/AerofagiaIcon';
import AfteIcon from '../../../shared/Icons/symptoms/AfteIcon';
import AlitosiIcon from '../../../shared/Icons/symptoms/AlitosiIcon';
import AllergiaIcon from '../../../shared/Icons/symptoms/AllergiaIcon';
import AlluceValgoIcon from '../../../shared/Icons/symptoms/AlluceValgoIcon';
import AlopeciaIcon from '../../../shared/Icons/symptoms/AlopeciaIcon';
import AnsiaIcon from '../../../shared/Icons/symptoms/AnsiaIcon';
import ApneaNotturnaIcon from '../../../shared/Icons/symptoms/ApneaNotturnaIcon';
import ArtrosiIcon from '../../../shared/Icons/symptoms/ArtrosiIcon';
import AsteniaSessualeIcon from '../../../shared/Icons/symptoms/AsteniaSessualeIcon';
import BalaniteIcon from '../../../shared/Icons/symptoms/BalaniteIcon';
import BlefariteIcon from '../../../shared/Icons/symptoms/BlefariteIcon';
import BruxismoIcon from '../../../shared/Icons/symptoms/BruxismoIcon';
import CadutaDeiCapelliIcon from '../../../shared/Icons/symptoms/CadutaDeiCapelliIcon';
import CalliAiPiediIcon from '../../../shared/Icons/symptoms/CalliAiPiediIcon';
import CandidaIcon from '../../../shared/Icons/symptoms/CandidaIcon';
import CapelliSecchiEDanneggiatiIcon from '../../../shared/Icons/symptoms/CapelliSecchiEDanneggiatiIcon';
import CarenzaDiFerroIcon from '../../../shared/Icons/symptoms/CarenzaDiFerroIcon';
import CarenzaDiVitamineIcon from '../../../shared/Icons/symptoms/CarenzaDiVitamineIcon';
import CartilagineDelGinocchioConsumataIcon from '../../../shared/Icons/symptoms/CartilagineDelGinocchioConsumataIcon';
import CefaleaIcon from '../../../shared/Icons/symptoms/CefaleaIcon';
import CelluliteIcon from '../../../shared/Icons/symptoms/CelluliteIcon';
import CicatriciECheloidiIcon from '../../../shared/Icons/symptoms/CicatriciECheloidiIcon';
import CinetosiIcon from '../../../shared/Icons/symptoms/CinetosiIcon';
import CistiteIcon from '../../../shared/Icons/symptoms/CistiteIcon';
import ColesteroloAltoIcon from '../../../shared/Icons/symptoms/ColesteroloAltoIcon';
import ColonIrritabileIcon from '../../../shared/Icons/symptoms/ColonIrritabileIcon';
import ColpoDellaStregaIcon from '../../../shared/Icons/symptoms/ColpoDellaStregaIcon';
import ColpoDiCaloreIcon from '../../../shared/Icons/symptoms/ColpoDiCaloreIcon';
import ColpoDiFrustaIcon from '../../../shared/Icons/symptoms/ColpoDiFrustaIcon';
import CongestioneNasaleIcon from '../../../shared/Icons/symptoms/CongestioneNasaleIcon';
import CongiuntiviteIcon from '../../../shared/Icons/symptoms/CongiuntiviteIcon';
import ConvalescenzaIcon from '../../../shared/Icons/symptoms/ConvalescenzaIcon';
import CouperoseIcon from '../../../shared/Icons/symptoms/CouperoseIcon';
import CrampiMuscolariIcon from '../../../shared/Icons/symptoms/CrampiMuscolariIcon';
import DentiGialliIcon from '../../../shared/Icons/symptoms/DentiGialliIcon';
import DentiSensibiliIcon from '../../../shared/Icons/symptoms/DentiSensibiliIcon';
import DermatiteAtopicaIcon from '../../../shared/Icons/symptoms/DermatiteAtopicaIcon';
import DermatiteSeborroicaIcon from '../../../shared/Icons/symptoms/DermatiteSeborroicaIcon';
import DermatiteDaPannolinoIcon from '../../../shared/Icons/symptoms/DermatiteDaPannolinoIcon';
import DiarreaIcon from '../../../shared/Icons/symptoms/DiarreaIcon';
import DifeseImmunitarieBasseIcon from '../../../shared/Icons/symptoms/DifeseImmunitarieBasseIcon';
import DifficoltàDiConcentrazioneIcon from '../../../shared/Icons/symptoms/DifficoltàDiConcentrazioneIcon';
import DigestioneLentaEDifficileIcon from '../../../shared/Icons/symptoms/DigestioneLentaEDifficileIcon';
import DisidrosiDiManiEPiediIcon from '../../../shared/Icons/symptoms/DisidrosiDiManiEPiediIcon';
import DoloriArticolariIcon from '../../../shared/Icons/symptoms/DoloriArticolariIcon';
import DoloriMestrualiIcon from '../../../shared/Icons/symptoms/DoloriMestrualiIcon';
import EmatomaCutaneoIcon from '../../../shared/Icons/symptoms/EmatomaCutaneoIcon';
import EmicraniaIcon from '../../../shared/Icons/symptoms/EmicraniaIcon';
import EmoglobinaBassaIcon from '../../../shared/Icons/symptoms/EmoglobinaBassaIcon';
import EmorroidiIcon from '../../../shared/Icons/symptoms/EmorroidiIcon';
import EndometriosiIcon from '../../../shared/Icons/symptoms/EndometriosiIcon';
import EpistassiIcon from '../../../shared/Icons/symptoms/EpistassiIcon';
import EritemaSolareIcon from '../../../shared/Icons/symptoms/EritemaSolareIcon';
import FaringiteIcon from '../../../shared/Icons/symptoms/FaringiteIcon';
import FebbreIcon from '../../../shared/Icons/symptoms/FebbreIcon';
import FeriteIcon from '../../../shared/Icons/symptoms/FeriteIcon';
import FibromialgiaIcon from '../../../shared/Icons/symptoms/FibromialgiaIcon';
import FollicoliteDaDepilazioneIcon from '../../../shared/Icons/symptoms/FollicoliteDaDepilazioneIcon';
import ForforaIcon from '../../../shared/Icons/symptoms/ForforaIcon';
import FragilitàCapillareIcon from '../../../shared/Icons/symptoms/FragilitàCapillareIcon';
import FungoDiMareIcon from '../../../shared/Icons/symptoms/FungoDiMareIcon';
import GambePesantiIcon from '../../../shared/Icons/symptoms/GambePesantiIcon';
import GeloniAManiEPiediIcon from '../../../shared/Icons/symptoms/GeloniAManiEPiediIcon';
import GengiviteIcon from '../../../shared/Icons/symptoms/GengiviteIcon';
import GonfioreAddominaleIcon from '../../../shared/Icons/symptoms/GonfioreAddominaleIcon';
import HerpesLabialeIcon from '../../../shared/Icons/symptoms/HerpesLabialeIcon';
import ImpetigineIcon from '../../../shared/Icons/symptoms/ImpetigineIcon';
import InfluenzaIcon from '../../../shared/Icons/symptoms/InfluenzaIcon';
import InsonniaIcon from '../../../shared/Icons/symptoms/InsonniaIcon';
import IntestinoPigroIcon from '../../../shared/Icons/symptoms/IntestinoPigroIcon';
import IntolleranzaAlLattosioIcon from '../../../shared/Icons/symptoms/IntolleranzaAlLattosioIcon';
import IperpigmentazioneCutaneaIcon from '../../../shared/Icons/symptoms/IperpigmentazioneCutaneaIcon';
import IpertensioneIcon from '../../../shared/Icons/symptoms/IpertensioneIcon';
import LabbraSeccheEScrepolateIcon from '../../../shared/Icons/symptoms/LabbraSeccheEScrepolateIcon';
import LaringiteIcon from '../../../shared/Icons/symptoms/LaringiteIcon';
import MalDOrecchioIcon from '../../../shared/Icons/symptoms/MalDOrecchioIcon';
import MalDiGolaIcon from '../../../shared/Icons/symptoms/MalDiGolaIcon';
import MalDiSchienaIcon from '../../../shared/Icons/symptoms/MalDiSchienaIcon';
import MalDiTestaIcon from '../../../shared/Icons/symptoms/MalDiTestaIcon';
import MenopausaIcon from '../../../shared/Icons/symptoms/MenopausaIcon';
import MetatarsalgiaIcon from '../../../shared/Icons/symptoms/MetatarsalgiaIcon';
import MicosiCutaneeIcon from '../../../shared/Icons/symptoms/MicosiCutaneeIcon';
import MigliorareMemoriaEConcentrazioneIcon from '../../../shared/Icons/symptoms/MigliorareMemoriaEConcentrazioneIcon';
import OcchiRossiIcon from '../../../shared/Icons/symptoms/OcchiRossiIcon';
import OcchiSecchiIcon from '../../../shared/Icons/symptoms/OcchiSecchiIcon';
import OcchiDiPerniceIcon from '../../../shared/Icons/symptoms/OcchiDiPerniceIcon';
import OcchiaieIcon from '../../../shared/Icons/symptoms/OcchiaieIcon';
import OnicofagiaIcon from '../../../shared/Icons/symptoms/OnicofagiaIcon';
import OnicomicosiIcon from '../../../shared/Icons/symptoms/OnicomicosiIcon';
import OsteoporosiIcon from '../../../shared/Icons/symptoms/OsteoporosiIcon';
import OtiteIcon from '../../../shared/Icons/symptoms/OtiteIcon';
import ParassitosiCutaneaDegliAnimaliIcon from '../../../shared/Icons/symptoms/ParassitosiCutaneaDegliAnimaliIcon';
import ParodontiteEGengiviteIcon from '../../../shared/Icons/symptoms/ParodontiteEGengiviteIcon';
import PediculosiIcon from '../../../shared/Icons/symptoms/PediculosiIcon';
import PelleGrassaDelVisoIcon from '../../../shared/Icons/symptoms/PelleGrassaDelVisoIcon';
import PelleGrassaDellaSchienaIcon from '../../../shared/Icons/symptoms/PelleGrassaDellaSchienaIcon';
import PelleSeccaIcon from '../../../shared/Icons/symptoms/PelleSeccaIcon';
import PelleSensibileIcon from '../../../shared/Icons/symptoms/PelleSensibileIcon';
import PerderePesoIcon from '../../../shared/Icons/symptoms/PerderePesoIcon';
import PiagheDaDecubitoIcon from '../../../shared/Icons/symptoms/PiagheDaDecubitoIcon';
import PiedeDiabeticoIcon from '../../../shared/Icons/symptoms/PiedeDiabeticoIcon';
import PiedeDAtletaIcon from '../../../shared/Icons/symptoms/PiedeDAtletaIcon';
import PiedePiattoIcon from '../../../shared/Icons/symptoms/PiedePiattoIcon';
import PiediGonfiIcon from '../../../shared/Icons/symptoms/PiediGonfiIcon';
import PiediSecchiIcon from '../../../shared/Icons/symptoms/PiediSecchiIcon';
import PressioneBassaIcon from '../../../shared/Icons/symptoms/PressioneBassaIcon';
import PruritoAcquagenicoIcon from '../../../shared/Icons/symptoms/PruritoAcquagenicoIcon';
import PruritoIntimoFemminileIcon from '../../../shared/Icons/symptoms/PruritoIntimoFemminileIcon';
import PruritoIntimoMaschileIcon from '../../../shared/Icons/symptoms/PruritoIntimoMaschileIcon';
import PsoriasiIcon from '../../../shared/Icons/symptoms/PsoriasiIcon';
import PuntiNeriIcon from '../../../shared/Icons/symptoms/PuntiNeriIcon';
import PuntureDiInsettiIcon from '../../../shared/Icons/symptoms/PuntureDiInsettiIcon';
import PuntureDiMedusaIcon from '../../../shared/Icons/symptoms/PuntureDiMedusaIcon';
import RagadiAlSenoIcon from '../../../shared/Icons/symptoms/RagadiAlSenoIcon';
import RaffreddoreIcon from '../../../shared/Icons/symptoms/RaffreddoreIcon';
import RashCutaneoIcon from '../../../shared/Icons/symptoms/RashCutaneoIcon';
import ReflussoGastroesofageoIcon from '../../../shared/Icons/symptoms/ReflussoGastroesofageoIcon';
import RiniteAllergicaIcon from '../../../shared/Icons/symptoms/RiniteAllergicaIcon';
import RitenzioneIdricaIcon from '../../../shared/Icons/symptoms/RitenzioneIdricaIcon';
import RosaceaIcon from '../../../shared/Icons/symptoms/RosaceaIcon';
import RugheIcon from '../../../shared/Icons/symptoms/RugheIcon';
import RussareIcon from '../../../shared/Icons/symptoms/RussareIcon';
import ScabbiaIcon from '../../../shared/Icons/symptoms/ScabbiaIcon';
import ScottatureIcon from '../../../shared/Icons/symptoms/ScottatureIcon';
import SecchezzaVaginaleIcon from '../../../shared/Icons/symptoms/SecchezzaVaginaleIcon';
import SindromeMetabolicaIcon from '../../../shared/Icons/symptoms/SindromeMetabolicaIcon';
import SinusiteIcon from '../../../shared/Icons/symptoms/SinusiteIcon';
import SmagliatureIcon from '../../../shared/Icons/symptoms/SmagliatureIcon';
import SpossatezzaIcon from '../../../shared/Icons/symptoms/SpossatezzaIcon';
import StanchezzaIcon from '../../../shared/Icons/symptoms/StanchezzaIcon';
import StanchezzaFisicaEMentaleIcon from '../../../shared/Icons/symptoms/StanchezzaFisicaEMentaleIcon';
import StitichezzaIcon from '../../../shared/Icons/symptoms/StitichezzaIcon';
import StomatiteIcon from '../../../shared/Icons/symptoms/StomatiteIcon';
import SudorazioneDeiPiediIcon from '../../../shared/Icons/symptoms/SudorazioneDeiPiediIcon';
import SudorazioneDelleAscelleIcon from '../../../shared/Icons/symptoms/SudorazioneDelleAscelleIcon';
import TalloniScrepolatiIcon from '../../../shared/Icons/symptoms/TalloniScrepolatiIcon';
import TappoDiCerumeIcon from '../../../shared/Icons/symptoms/TappoDiCerumeIcon';
import TignaIcon from '../../../shared/Icons/symptoms/TignaIcon';
import TorcicolloIcon from '../../../shared/Icons/symptoms/TorcicolloIcon';
import TosseGrassaIcon from '../../../shared/Icons/symptoms/TosseGrassaIcon';
import TosseSeccaIcon from '../../../shared/Icons/symptoms/TosseSeccaIcon';
import TossineInEccessoIcon from '../../../shared/Icons/symptoms/TossineInEccessoIcon';
import TrigliceridiAltiIcon from '../../../shared/Icons/symptoms/TrigliceridiAltiIcon';
import UnghiaIncarnitaIcon from '../../../shared/Icons/symptoms/UnghiaIncarnitaIcon';
import UstioniIcon from '../../../shared/Icons/symptoms/UstioniIcon';
import VaginiteIcon from '../../../shared/Icons/symptoms/VaginiteIcon';
import VeneVaricoseIcon from '../../../shared/Icons/symptoms/VeneVaricoseIcon';
import VerruchePlantariIcon from '../../../shared/Icons/symptoms/VerruchePlantariIcon';
import VertiginiIcon from '../../../shared/Icons/symptoms/AciditaDiStomacoIcon';
import XerosiIcon from '../../../shared/Icons/symptoms/XerosiIcon';
import ZampeDiGallinaIcon from '../../../shared/Icons/symptoms/ZampeDiGallinaIcon';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

export const SymptomIcon = ({
  type,
  primaryColor,
  secondaryColor,
  fallbackImage,
  width,
}) => {
  switch (type) {
    case 'Mal di testa':
      return (
        <MalDiTestaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Dolori articolari':
      return (
        <DoloriArticolariIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Febbre':
      return (
        <FebbreIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Raffreddore':
      return (
        <RaffreddoreIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Stanchezza':
      return (
        <StanchezzaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Vertigini':
      return (
        <VertiginiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Spossatezza':
      return (
        <SpossatezzaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Congestione nasale':
      return (
        <CongestioneNasaleIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Allergia':
      return (
        <AllergiaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Abrasioni':
      return (
        <AbrasioniIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Acetone nei bambini e negli adulti':
      return (
        <AcetoneNeiBambiniENegliAdultiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Acidità di stomaco':
      return (
        <AciditaDiStomacoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Acne':
      return (
        <AcneIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Aerofagia':
      return (
        <AerofagiaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Afte':
      return (
        <AfteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Alitosi':
      return (
        <AlitosiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Alluce valgo':
      return (
        <AlluceValgoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Alopecia':
      return (
        <AlopeciaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Ansia':
      return (
        <AnsiaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Apnea notturna':
      return (
        <ApneaNotturnaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Artrosi':
      return (
        <ArtrosiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Astenia Sessuale':
      return (
        <AsteniaSessualeIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Balanite':
      return (
        <BalaniteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Blefarite':
      return (
        <BlefariteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Bruxismo':
      return (
        <BruxismoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Caduta dei Capelli':
      return (
        <CadutaDeiCapelliIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Calli ai piedi':
      return (
        <CalliAiPiediIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Candida':
      return (
        <CandidaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Capelli Secchi e Danneggiati':
      return (
        <CapelliSecchiEDanneggiatiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Carenza di Ferro':
      return (
        <CarenzaDiFerroIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Carenza di Vitamine':
      return (
        <CarenzaDiVitamineIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Cartilagine del ginocchio consumata':
      return (
        <CartilagineDelGinocchioConsumataIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Cefalea':
      return (
        <CefaleaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Cellulite':
      return (
        <CelluliteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Cicatrici e Cheloidi':
      return (
        <CicatriciECheloidiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Cinetosi':
      return (
        <CinetosiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Cistite':
      return (
        <CistiteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Colesterolo Alto':
      return (
        <ColesteroloAltoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Colon Irritabile':
      return (
        <ColonIrritabileIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Colpo della strega':
      return (
        <ColpoDellaStregaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Colpo di calore':
      return (
        <ColpoDiCaloreIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Colpo di frusta':
      return (
        <ColpoDiFrustaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Congiuntivite':
      return (
        <CongiuntiviteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Convalescenza':
      return (
        <ConvalescenzaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Couperose':
      return (
        <CouperoseIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Crampi Muscolari':
      return (
        <CrampiMuscolariIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Denti Gialli':
      return (
        <DentiGialliIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Denti Sensibili':
      return (
        <DentiSensibiliIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Dermatite Atopica':
      return (
        <DermatiteAtopicaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Dermatite Seborroica':
      return (
        <DermatiteSeborroicaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Dermatite da pannolino':
      return (
        <DermatiteDaPannolinoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Diarrea':
      return (
        <DiarreaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Difese Immunitarie Basse':
      return (
        <DifeseImmunitarieBasseIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Difficoltà di Concentrazione':
      return (
        <DifficoltàDiConcentrazioneIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Digestione lenta e difficile':
      return (
        <DigestioneLentaEDifficileIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Disidrosi di Mani e Piedi':
      return (
        <DisidrosiDiManiEPiediIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Dolori Mestruali':
      return (
        <DoloriMestrualiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Ematoma Cutaneo':
      return (
        <EmatomaCutaneoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Emicrania':
      return (
        <EmicraniaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Emoglobina bassa':
      return (
        <EmoglobinaBassaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Emorroidi':
      return (
        <EmorroidiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Endometriosi':
      return (
        <EndometriosiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Epistassi':
      return (
        <EpistassiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Eritema Solare':
      return (
        <EritemaSolareIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Faringite':
      return (
        <FaringiteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Ferite':
      return (
        <FeriteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Fibromialgia':
      return (
        <FibromialgiaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Follicolite da depilazione':
      return (
        <FollicoliteDaDepilazioneIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Forfora':
      return (
        <ForforaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Fragilità Capillare':
      return (
        <FragilitàCapillareIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Fungo Di Mare':
      return (
        <FungoDiMareIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Gambe Pesanti':
      return (
        <GambePesantiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Geloni a Mani e Piedi':
      return (
        <GeloniAManiEPiediIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Gengivite':
      return (
        <GengiviteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Gonfiore Addominale':
      return (
        <GonfioreAddominaleIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Herpes Labiale':
      return (
        <HerpesLabialeIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Impetigine':
      return (
        <ImpetigineIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Influenza':
      return (
        <InfluenzaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Insonnia':
      return (
        <InsonniaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Intestino Pigro':
      return (
        <IntestinoPigroIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Intolleranza Al Lattosio':
      return (
        <IntolleranzaAlLattosioIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Iperpigmentazione Cutanea':
      return (
        <IperpigmentazioneCutaneaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Ipertensione':
      return (
        <IpertensioneIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Labbra Secche e Screpolate':
      return (
        <LabbraSeccheEScrepolateIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Laringite':
      return (
        <LaringiteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Mal d orecchio':
      return (
        <MalDOrecchioIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Mal di Gola':
      return (
        <MalDiGolaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Mal di schiena':
      return (
        <MalDiSchienaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Menopausa':
      return (
        <MenopausaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Metatarsalgia':
      return (
        <MetatarsalgiaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Micosi Cutanee':
      return (
        <MicosiCutaneeIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Migliorare memoria e concentrazione':
      return (
        <MigliorareMemoriaEConcentrazioneIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Occhi Rossi':
      return (
        <OcchiRossiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Occhi secchi':
      return (
        <OcchiSecchiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Occhi di Pernice':
      return (
        <OcchiDiPerniceIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Occhiaie':
      return (
        <OcchiaieIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Onicofagia':
      return (
        <OnicofagiaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Onicomicosi':
      return (
        <OnicomicosiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Osteoporosi':
      return (
        <OsteoporosiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Otite':
      return (
        <OtiteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Parassitosi cutanea degli animali':
      return (
        <ParassitosiCutaneaDegliAnimaliIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Parodontite e Gengivite':
      return (
        <ParodontiteEGengiviteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Pediculosi':
      return (
        <PediculosiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Pelle Grassa del Viso':
      return (
        <PelleGrassaDelVisoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Pelle Grassa della Schiena':
      return (
        <PelleGrassaDellaSchienaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Pelle Secca':
      return (
        <PelleSeccaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Pelle Sensibile':
      return (
        <PelleSensibileIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Perdere peso':
      return (
        <PerderePesoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Piaghe da Decubito':
      return (
        <PiagheDaDecubitoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Piede Diabetico':
      return (
        <PiedeDiabeticoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Piede d Atleta':
      return (
        <PiedeDAtletaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Piede piatto':
      return (
        <PiedePiattoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Piedi Gonfi':
      return (
        <PiediGonfiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Piedi Secchi':
      return (
        <PiediSecchiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Pressione bassa':
      return (
        <PressioneBassaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Prurito Acquagenico':
      return (
        <PruritoAcquagenicoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Prurito Intimo Femminile':
      return (
        <PruritoIntimoFemminileIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Prurito Intimo Maschile':
      return (
        <PruritoIntimoMaschileIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Psoriasi':
      return (
        <PsoriasiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Punti Neri':
      return (
        <PuntiNeriIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Punture di Insetti':
      return (
        <PuntureDiInsettiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Punture di Medusa':
      return (
        <PuntureDiMedusaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Ragadi al Seno':
      return (
        <RagadiAlSenoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Rash cutaneo':
      return (
        <RashCutaneoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Reflusso Gastroesofageo':
      return (
        <ReflussoGastroesofageoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Rinite allergica':
      return (
        <RiniteAllergicaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Ritenzione idrica':
      return (
        <RitenzioneIdricaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Rosacea':
      return (
        <RosaceaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Rughe':
      return (
        <RugheIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Russare':
      return (
        <RussareIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Scabbia':
      return (
        <ScabbiaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Scottature':
      return (
        <ScottatureIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Secchezza Vaginale':
      return (
        <SecchezzaVaginaleIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Sindrome metabolica':
      return (
        <SindromeMetabolicaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Sinusite':
      return (
        <SinusiteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Smagliature':
      return (
        <SmagliatureIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Stanchezza Fisica e Mentale':
      return (
        <StanchezzaFisicaEMentaleIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Stitichezza':
      return (
        <StitichezzaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Stomatite':
      return (
        <StomatiteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Sudorazione dei piedi':
      return (
        <SudorazioneDeiPiediIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Sudorazione delle Ascelle':
      return (
        <SudorazioneDelleAscelleIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Talloni Screpolati':
      return (
        <TalloniScrepolatiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Tappo di Cerume':
      return (
        <TappoDiCerumeIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Tigna':
      return (
        <TignaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Torcicollo':
      return (
        <TorcicolloIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Tosse grassa':
      return (
        <TosseGrassaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Tosse Secca':
      return (
        <TosseSeccaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Tossine in Eccesso':
      return (
        <TossineInEccessoIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Trigliceridi Alti':
      return (
        <TrigliceridiAltiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Unghia Incarnita':
      return (
        <UnghiaIncarnitaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Ustioni':
      return (
        <UstioniIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Vaginite':
      return (
        <VaginiteIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Vene Varicose':
      return (
        <VeneVaricoseIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Verruche Plantari':
      return (
        <VerruchePlantariIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Xerosi':
      return (
        <XerosiIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    case 'Zampe di Gallina':
      return (
        <ZampeDiGallinaIcon
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          width={width || 160}
        />
      );
    default:
      return fallbackImage ? (
        <ImageDispatcher
          alt={`Sintomo ${fallbackImage}`}
          src={fallbackImage}
          style={{ width: '100%' }}
        />
      ) : null;
  }
};
